import { c as _c } from "react/compiler-runtime";
import type { Article, WithContext } from 'schema-dts';
import { LinkedDataJson } from 'src/shared/seo/LinkedDataJson';
import { useCompareContext } from '../Context';
export function CompareArticleLinkedData() {
  const $ = _c(2);
  const {
    compareData: t0
  } = useCompareContext();
  const {
    updatedDate
  } = t0;
  if (!updatedDate) {
    return null;
  }
  let t1;
  if ($[0] !== updatedDate) {
    const schema = {
      "@context": "https://schema.org",
      "@type": "Article",
      dateModified: updatedDate
    };
    t1 = <LinkedDataJson id="compare-article-linked-data" schema={schema} />;
    $[0] = updatedDate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}